import { authFetch } from "./authFetch";

const BASE_URL = window.env.API_BASE_URL;

export const getAllGateways = async () => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/GetAll`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        return [];
      }
      throw new Error("Failed to fetch gateways");
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const addNewGateway = async serialNumber => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/Register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ olySerialNumber: serialNumber }),
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("Gateway not authenticated");
      }
      throw new Error("Failed to add new gateway");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const deleteGatewayById = async id => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/DeleteById/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete gateway with ID ${id}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const updateGatewayById = async (id, name, notificationsEnabled) => {
  const body = { name: name, notificationsEnabled: notificationsEnabled };
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/UpdateById/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    const text = await response.text();

    if (!response.ok) {
      throw new Error(text || "_unknownError");
    }
    return text;

    // if (!response.ok) {
    //   throw new Error(`Failed to update gateway with ID ${id}`);
    // }

    // return await response.json();
  } catch (error) {
    throw error;
  }
};

// Assign Gateway
export const assignGatewayToUser = async (email, serialNumbers) => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/AssignMultiple`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, olySerialNumbers: serialNumbers }),
    });

    if (!response.ok) {
      throw new Error("Failed to assign gateway to user");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const getAllOwnedGateways = async () => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/GetAllOwned`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      if (response.status === 404) {
        return [];
      }
      throw new Error("Failed to fetch owned gateways");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching owned gateways:", error);
    return [];
  }
};

export const unassignGatewayFromUser = async (serialNumber, userId) => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/Unassign`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ OlySerialNumber: serialNumber, userId }),
    });

    if (!response.ok) {
      throw new Error("Failed to unassign gateway from user");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const getAllMembers = async () => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/GetAllMembers`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      if (response.status === 404) {
        return [];
      }
      const text = await response.text();
      throw new Error(text || "_unknownError");
    }
    if (response.status === 200) {
      return await response.json();
    }
  } catch (error) {
    console.error("Failed to fetch members");
    return null;
  }
};
